module.exports = __webpack_public_path__ + "static/img/creativity.3bc4b4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact/creativity.png
// module id = dfOj
// module chunks = 1